import { MAT_TABS_CONFIG, MatTabsConfig } from '@angular/material/tabs';

export const matTabsConfigProvider = {
  provide: MAT_TABS_CONFIG,
  useValue: { animationDuration: '0', stretchTabs: false } as MatTabsConfig,
};
